import { AdditionalSearchParams } from './index';

export type IntroSearchForm = AdditionalSearchParams;

export const introSearchForm: IntroSearchForm = {
  vehicleIds: [],
  namesManufacturer: [],
  namesModel: [],
  codeUsage: [],
  codeBody: [],
  locations: [],
  queryString: ''
};
